<template>
  <v-dialog v-model="dialog" persistent scrollable max-width="80%">
    <v-card class="px-3 py-0">
      <v-card-title class="pa-0">
        <v-col class="text-right pb-0 pt-1 px-0">
          <v-btn icon dark @click="close()">
            <v-icon color="primary">mdi-close</v-icon>
          </v-btn>
        </v-col>
        <v-col class="text-center pt-0 pb-3 px-6" cols="12">
          <h1 style="font-size: 26px" class="mb-1 pt-0">Edição de {{tipo_consulta=='guias'? 'guia' : 'item'}}</h1>
           <span style="font-size:16px;font-weight:normal" v-if="tipo_consulta=='guias'">{{itemSelecionado.nome_beneficiario}}</span>
           <span style="font-size:16px;font-weight:normal" v-else-if="tipo_consulta=='itens'">{{itemSelecionado.descricao_procedimento}}</span>
        </v-col>
       <v-row  wrap class="ma-0 px-6" v-if="tipo_consulta=='guias'">
            <v-col class="text-left pb-2 pt-0">
                <span class="card-title-form-guia textsRec" style="display: block">Ident. prestador:</span>
                <span style="font-size:16px;font-weight:normal">{{itemSelecionado.identificador_prestador_captura}}</span>
            </v-col>
            <v-col class="text-left pb-2 pt-0">
                <span class="card-title-form-guia textsRec" style="display: block">Núm. lote:</span>
                <span style="font-size:16px;font-weight:normal">{{itemSelecionado.numero_lote}}</span>
            </v-col>
            <v-col class="text-left pb-2 pt-0">
                <span class="card-title-form-guia textsRec" style="display: block">Núm. guia prestador: </span>
                <span style="font-size:16px;font-weight:normal">{{itemSelecionado.numero_guia_prestador}}</span>
            </v-col>
            <v-col class="text-left pb-2 pt-0">
                <span class="card-title-form-guia textsRec" style="display: block">Núm. carteirinha: </span>
                <span style="font-size:16px;font-weight:normal; color: error">{{ itemSelecionado.carteira_beneficiario}}</span>
            </v-col>
            <v-col class="text-left pb-2 pt-0">
                <span class="card-title-form-guia textsRec" style="display: block">Valor da glosa: </span>
                <span style="font-size:16px;font-weight:normal; color: error">{{ itemSelecionado.valor_glosado | formatPrice }}</span>
            </v-col>
            </v-row>
            <v-row  wrap class="ma-0 px-6" v-else-if="tipo_consulta=='itens'">
            <v-col class="text-left pb-2 pt-0">
                <span class="card-title-form-guia textsRec" style="display: block">Ident. prestador:</span>
                <span style="font-size:16px;font-weight:normal">{{itemSelecionado.identificador_prestador_captura}}</span>
            </v-col>
            <v-col class="text-left pb-2 pt-0">
                <span class="card-title-form-guia textsRec" style="display: block">Núm. lote:</span>
                <span style="font-size:16px;font-weight:normal">{{itemSelecionado.numero_lote}}</span>
            </v-col>
            <v-col class="text-left pb-2 pt-0">
                <span class="card-title-form-guia textsRec" style="display: block">Núm. guia prestador: </span>
                <span style="font-size:16px;font-weight:normal">{{itemSelecionado.numero_guia_prestador}}</span>
            </v-col>
            <v-col class="text-left pb-2 pt-0">
                <span class="card-title-form-guia textsRec" style="display: block">Data execução: </span>
                <span style="font-size:16px;font-weight:normal; color: error">{{ itemSelecionado.data_execucao | formatDate}}</span>
            </v-col>
            <v-col class="text-left pb-2 pt-0">
                <span class="card-title-form-guia textsRec" style="display: block">Valor glosado: </span>
                <span style="font-size:16px;font-weight:normal; color: error">{{ itemSelecionado.valor_glosado | formatPrice}}</span>
            </v-col>
            </v-row>
      </v-card-title>
      <v-card-text class="py-0">
       <v-form ref="edicaoIndividualForm">
        <v-row class="py-3 px-4">
            <v-col class="px-2 py-0" cols="12">
                <label>Justificativa</label>
                <v-textarea
                    v-model="formData.data.justificativa"
                    persistent-hint
                    outlined
                    dense
                    :rules="tipo_consulta=='guias'?[this.formData.data.recursado_total? this.formRules.requiredField : null, this.RegraVariavel  ? this.formRules.maxLengthRule(this.LimiteCaracteres) : (this.Regra500? this.formRules.max500 : this.formRules.max150)] : [this.formData.data.valor_recursado > 0 ? this.formRules.requiredField : null, this.RegraVariavel   ? this.formRules.maxLengthRule(this.LimiteCaracteres) : (this.Regra500? this.formRules.max500: this.formRules.max150)]"
                  ></v-textarea>
            </v-col>
            <!-- <v-col class="px-0 py-0" cols="12">
              <formDadosExtras
              :itemSelecionado="null"
              tipo="Recurso"
              :dadosExtrasConfig="dadosExtrasConfig"
              :grupoEconomico="grupoEconomico"
              :dialog="dialog"
              :retornoForm="(condi) => retornoFormData(condi)"
              :formDataPre="formDataPre"
              :reapresentacao="reapresentacao"
              idForm="FormRecursoMassa"
            />
            <formDadosExtras
              v-if="reapresentacao"
              :itemSelecionado="null"
              tipo="Reapresentacao"
              :dadosExtrasConfig="dadosExtrasConfig"
              :grupoEconomico="grupoEconomico"
              :dialog="dialog"
              :retornoForm="(condi) => retornoFormData(condi)"
              :formDataPre="formDataPre"
              :reapresentacao="reapresentacao"
              idForm="FormReapresentacaoMassa"
            />
            </v-col> -->
            <v-col class="px-2 py-0" cols="4" v-if="tipo_consulta=='itens'">
                <label>Valor recursado</label>
                  <v-text-field
                    v-model="formData.valorRecursado"
                    persistent-hint
                    class="my-0"
                    outlined
                    dense
                    @input="formatPrice(formData)"
                    @blur="formatPrice(formData)"
                  ></v-text-field>
            </v-col>
            <v-col class="px-2 py-0 pt-1" cols="8">
               <v-radio-group 
                v-model="formData.data.recursado_total" 
                row 
                small 
                @change="updateData(formData)" 
                :rules="tipo_consulta=='guias' && formData.data.recursado_total == null 
                  || formData.data.valor_recursado==0 && formData.data.recursado_total == null 
                  ? formRules.required :[]"
                >
                <v-radio
                small
                    label="Acatar integral"
                    :value="false"
                ></v-radio>
                <v-radio
                small
                    label="Recursar integral"
                    :value="true"
                ></v-radio>
            </v-radio-group>
            </v-col>
        </v-row>
       </v-form>
      </v-card-text>
      <v-card-actions class="px-9">
          <v-btn
          outlined
            color="primary"
            height="30px"
            small
            depressed
            @click="close()"
          >
            Cancelar
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            height="30px"
            small
            depressed
            @click="saveSelect(formData)"
          >
            Salvar edição
          </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from "vuex";
import moment from "moment";

//import formDadosExtras from "@/components/recebiveis/recursos_de_glosa_edicao/formDadosExtras"
moment.locale("pt-BR");
export default {
  // components:{
  //   formDadosExtras
  // },
  data() {
    return {
      formData:{
        data: {
          id: null,
          justificativa: null,
          valor_recursado: null,
          recursado_total: null,
          obj_type: null,
          dados_extras: null
        },
        valorRecursado: null,
        valorAcatado: null,
      },
      condi: false,
      dadosExtrasPorTipo: {Recurso:[]},
      Regra500: false,
      RegraVariavel  : false,
      LimiteCaracteres: 0
    };
  },
  computed: {
    ...mapState({
      formRules: (state) => state.formRules,
    }),
    compoeRegras:()=>{
      if(this.dialog){
        if (this.tipo_consulta == 'itens') {
          if(this.RegraVariavel && this.formData.data.valor_recursado > 0)
            return [this.formRules.requiredField,this.formRules.maxLengthRule(this.LimiteCaracteres)]
          else if(this.Regra500 && this.formData.data.valor_recursado > 0)
            return [this.formRules.requiredField,this.formRules.max500]
          else if (this.formData.data.valor_recursado > 0)
            return[this.formRules.requiredField,this.formRules.max150]
          else 
            return null
        } else {
          if(this.RegraVariavel   && this.formData.data.valor_recursado > 0)
            return [this.formRules.requiredField,this.formRules.maxLengthRule(this.LimiteCaracteres)]
          else if(this.Regra500 && this.formData.data.recursado_total)
            return [this.formRules.requiredField,this.formRules.max500]
          else if (this.formData.data.recursado_total)
            return[this.formRules.requiredField, this.formRules.max150]
          else 
            return null
        }
      }
      return null
    },
  },
  watch: {
    dialog(bool){
      if (bool) {
        this.formData = {
                data: {
                  id: null,
                  justificativa: null,
                  valor_recursado: null,
                  recursado_total: null,
                  obj_type: null,
                  dados_extras: null
                },
          valorRecursado: null,
          valorAcatado: null,
        }, 
        this.formData.data = Object.assign(this.formData.data, this.itemSelecionado)
        this.formData.valorRecursado = this.itemSelecionado.valor_recursado
        this.formData.valorAcatado = this.itemSelecionado.valor_acatado
        this.formData.data.obj_type = this.tipo_consulta == 'guias' ?'guia':'item'
        this.formatPrice(this.formData)
        this.$refs.edicaoIndividualForm.resetValidation()
      } 
    },
    parametros(param){
        this.Regra500 = (param && param.RG_Versao && param.RG_Versao >= 40000)? true: false; 
        this.RegraVariavel   = param && param.RG_QTD_CARACTERES_JUSTIFICATIVA ? true: false; 
        this.LimiteCaracteres = param.RG_QTD_CARACTERES_JUSTIFICATIVA
    }
  },
  methods: {
    // compoeRegras(){
    //   if (this.tipo_consulta == 'itens') {
    //     if(this.Regra500 && this.formData.data.valor_recursado > 0)
    //       return [this.formRules.requiredField,this.formRules.max500]
    //     else if (this.formData.data.valor_recursado > 0)
    //       return[this.formRules.requiredField,this.formRules.max150]
    //     else 
    //       return null
    //   } else {
    //      if(this.Regra500 && this.formData.data.recursado_total)
    //       return [this.formRules.requiredField,this.formRules.max500]
    //     else if (this.formData.data.recursado_total)
    //       return[this.formRules.requiredField, this.formRules.max150]
    //     else 
    //       return null
    //   }
    // },
    updateData(formData) {
      if (this.tipo_consulta == 'itens') {
        if (!formData.data.recursado_total) {
          formData.valorRecursado = 0
          formData.data.valor_recursado = "0,00"
          formData.valorAcatado = formData.data.valor_glosado
          formData.data.valor_acatado = formData.data.valor_glosado
        } else {
          formData.valorAcatado = 0
          formData.data.valor_acatado = 0.00
          formData.valorRecursado = formData.data.valor_glosado
          formData.data.valor_recursado = formData.data.valor_glosado
        } 
        
        this.formatPrice(formData)
      }
    },
    formatPrice(item) {
      let value = !isNaN(parseFloat(item['valorRecursado'])) && isFinite(item['valorRecursado']) 
        ?(Number(item['valorRecursado'].toString().replace(',', '.'))/1).toFixed(2).replace(/[^\d]+/g,'') 
        :item['valorRecursado'].toString().replaceAll(/(!\d|\.|,)/g, '')
      let recurso = Number((Number(value)/100).toFixed(2))
      recurso = recurso > item.data.valor_glosado ?item.data.valor_glosado : recurso
      item.valorAcatado = item.data.valor_glosado - recurso
      let val = (Number(recurso.toString().replace(',', '.'))/1).toFixed(2).replace('.', ',')
      let result = val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
      if (recurso >= item.data.valor_glosado) {
        setTimeout(() => {
          item['valorRecursado'] = result
          item.data.recursado_total = true
          item.data.valor_recursado = item.data.valor_glosado
          item.data.valor_acatado = 0
        },100)
      } else {
        if (item['valorRecursado'] == '0,0' || item['valorRecursado'] == '0,000') {
          setTimeout(() => {
            item['valorRecursado'] = result
            item.data.recursado_total = false
            item.data.valor_recursado = 0
            item.data.valor_acatado = item.data.valor_glosado
          },100)
        } else {
          item.data.recursado_total = recurso == item.data.valor_glosado ? true : recurso== 0 ? false : recurso> 0 && recurso< item.data.valor_glosado ?null :null
          item.data.valor_recursado = recurso
          item.data.valor_acatado = (item.data.valor_glosado - recurso).toFixed(2)
          item['valorRecursado'] = result
        }
      }
    },
    saveSelect(formData) {
      this.formData.data.dados_extras = {}
      if (this.$refs.edicaoIndividualForm.validate())
      // && (this.condi || formData.data.dados_extras == null || !formData.data.dados_extras.length))
      { 
        formData.data.pagamento_id = this.pagamento_id
        //formData.data.dados_extras = JSON.stringify(this.formDataPre)
        this.save(true, [formData.data])
      }
    },
    retornoFormData(condi){
      this.condi = condi
    },
  },
  props: {
    close: Function,
    dadosExtrasConfig: Object,
    dialog: Boolean,
    formDataPre: Object,
    grupoEconomico: Number,
    itemSelecionado: Object,
    pagamento_id: String,
    parametros: Object,
    reapresentacao: Boolean,
    save: Function,
    tipo: String,
    tipo_consulta: String,
  }
}
</script>

<style>

</style>